import { Button, ListItemIcon, MenuItem, useTheme } from "@mui/material";
import pluralize from "pluralize";
import { labelButtonStyle } from "../../../../components/shared/PopupMenu";
import Loading from "../../../../components/shared/layout/Loading";
import { toastMessage } from "../../../../constants/strings";
import { toast } from "../../../../utils/snackbarHelper";
import { useLockRoutes } from "../../../../hooks/react-query/useDeliveryRoutes";
import { PlanTableFormat } from "../../../../types/planning/plan.type";
import { useSelectedServiceCenter } from "../../../../hooks/useSelectedServiceCenter";
import { useDateSearchParamOrFallbackToToday } from "../../../../hooks/useDateSearchParamOrFallbackToToday";
import { dateToInt } from "../../../../utils/dateTimeHelper";
import LockOpenIcon from "../../../../components/shared/icons/LockOpenIcon";

type UnlockRoutesMenuItemProps = {
  routes: PlanTableFormat[];
  /** Omit if don't want to call it after the action */
  handleClose?: () => void;
  clearSelection?: () => void;
};

export const UnlockRoutesMenuItem = ({
  routes,
  handleClose,
  clearSelection = () => {},
}: UnlockRoutesMenuItemProps) => {
  const theme = useTheme();
  const [serviceCenter] = useSelectedServiceCenter();
  const [selectedDate] = useDateSearchParamOrFallbackToToday();
  const dateInt = dateToInt(selectedDate);

  const lockRouteMutation = useLockRoutes({
    date: dateInt,
    sicId: serviceCenter.id,
    onSuccess: () => {
      handleClose?.();
      toast(toastMessage.shared.lockRoutes.success(routes.length, true), {
        variant: "success",
      });
      clearSelection();
    },
  });

  if (lockRouteMutation.isPending) {
    return <Loading label="lock" containerWidth={32} size={32} />;
  }

  return (
    <MenuItem
      onClick={() =>
        lockRouteMutation.mutate(
          routes.map((route) => ({
            id: route.id,
            isLocked: !route.isCommitted || false,
          }))
        )
      }
    >
      <ListItemIcon>
        <LockOpenIcon fillColor={theme.palette.grey[600]} />
      </ListItemIcon>
      <Button sx={labelButtonStyle} disableRipple>
        Unlock {pluralize("Route", routes.length)}
      </Button>
    </MenuItem>
  );
};
